import { render, staticRenderFns } from "./AddressUpdateDialog.vue?vue&type=template&id=764d70d2&scoped=true"
import script from "./AddressUpdateDialog.vue?vue&type=script&lang=ts"
export * from "./AddressUpdateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764d70d2",
  null
  
)

export default component.exports